"use client";

import { useTranslations } from "next-intl";
import { AppButton } from "@/components/design/forms";
import type { ParticipantFormData } from "./registrationFlowTypes";
import { CATEGORY_SELECT_OPTIONS } from "@/lib/participantFieldOptions";

export interface ParticipantChampionshipCategorySectionProps {
    participant: ParticipantFormData;
    errors: Record<string, string>;
    onUpdate: (data: Partial<ParticipantFormData>) => void;
}

export function ParticipantChampionshipCategorySection({
    participant,
    errors,
    onUpdate,
}: ParticipantChampionshipCategorySectionProps) {
    const t = useTranslations("strings.registrationFlow");
    const tf = useTranslations("strings.participantFieldOptions");

    return (
        <div className="min-w-0 max-w-full rounded-xl bg-fest-canvas p-3 sm:p-4">
            <h4 className="mb-3 text-sm font-bold uppercase tracking-wider text-fest-heading">
                {t("championshipInfoTitle")}
            </h4>

            <div>
                <label className="mb-1 block text-xs font-medium text-fest-heading">
                    {t("categoryLabel")}
                </label>
                <div className="grid min-w-0 w-full max-w-full grid-cols-3 gap-2 sm:gap-1.5">
                    {CATEGORY_SELECT_OPTIONS.map(({ value, labelKey }) => (
                        <AppButton
                            key={value}
                            type="button"
                            onClick={() =>
                                onUpdate({
                                    category: value as ParticipantFormData["category"],
                                })
                            }
                            className={`min-w-0 whitespace-normal break-words rounded-lg border-2 px-2 py-2 text-center text-xs font-semibold leading-tight transition-all sm:px-3 sm:text-sm ${
                                participant.category === value
                                    ? "border-fest-gold bg-fest-gold text-white shadow-md"
                                    : "border-fest-border-strong bg-white text-fest-heading hover:border-fest-gold hover:shadow"
                            }`}
                        >
                            {tf(labelKey)}
                        </AppButton>
                    ))}
                </div>
                {errors.category && (
                    <p className="mt-1 text-xs text-fest-red">{errors.category}</p>
                )}
            </div>
        </div>
    );
}
